var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexbox-container"},_vm._l((_vm.group),function(s,i){return _c('div',{key:i,staticClass:"flexbox-row"},[_c('Card',{attrs:{"name":s.name,"image":s.cover,"icon":s.thumbnail,"total-contents":s.totalContents,"type":_vm.type,"link":_vm.$urlBuilder(_vm.type, { slug: s.slug })}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }